/**
 * Community type as defined in EAG (Austrian Renewable Energy Expansion Act)
 */
export enum CommunityType {
  LOCAL = '16a',      // Local energy community (16a)
  CITIZEN = '16b',    // Citizen energy community (16b)
  REGIONAL = '16c'    // Regional energy community (16c)
}

/**
 * Legal entity type for a community
 */
export enum LegalEntityType {
  ASSOCIATION = 'Verein',     // Non-profit association
  CORPORATION = 'GmbH',       // Limited liability company
  INDIVIDUAL = 'Privatperson' // Individual person
}

/**
 * Identification type for community
 */
export enum CommunityIdentificationType {
  ZVR = 'ZVR',        // Association register number
  FB = 'FB',          // Company register number
  UID = 'UID'         // Tax identification number
} 